import { membersApi, type BranchMember } from '@/entities/Branch';

const MEMBERS_ITEMS_PER_PAGE = 100;

export async function fetchAllActiveMembers(): Promise<BranchMember[]> {
  const first = await membersApi.getMembers(1, MEMBERS_ITEMS_PER_PAGE, undefined, 'name', 'asc', {
    status: 'ACTIVE',
  });
  const collected = [...first.data];
  const totalPages = first.metadata.totalPages ?? 1;
  for (let page = 2; page <= totalPages; page += 1) {
    const result = await membersApi.getMembers(page, MEMBERS_ITEMS_PER_PAGE, undefined, 'name', 'asc', {
      status: 'ACTIVE',
    });
    collected.push(...result.data);
  }
  return collected;
}
